import React, { useEffect, useState } from 'react'
import { Button, Form, Input } from 'antd-mobile-v5'
import { CheckCircleFill } from 'antd-mobile-icons'
import { FormattedMessage, useIntl } from 'react-intl'
import { useInstructorSearch } from '../../services/hooks'

const SearchInstructor = ({
  form,
  idType,
  type,
  editable,
  initInstructorInfo,
  instructorVerify,
  setInstructorVerify,
  required,
}) => {
  const { formatMessage } = useIntl()
  const [instructor, setInstructor] = useState(initInstructorInfo)
  const { loading, run } = useInstructorSearch({
    onSuccess: (data) => {
      setInstructorVerify(true)
      form.setFields([
        {
          name: 'instructorNumber',
          errors: [],
        },
      ])
      setInstructor(data)
    },
    onError: (error) => {
      if (error.clientMsg) {
        form.setFields([
          {
            name: 'instructorNumber',
            errors: [error.clientMsg],
          },
        ])
        setInstructor(null)
        return true
      } else {
        return false
      }
    },
  })

  const search = () => {
    setInstructor(null)
    setInstructorVerify(false)
    const instructorNumber = form.getFieldValue('instructorNumber')
    if (!instructorNumber) {
      form.setFields([
        {
          name: 'instructorNumber',
          errors: [formatMessage({ id: 'dm-form-instructor-warning' })],
        },
      ])
      return
    }
    if (!/^\d+$/.test(instructorNumber)) {
      form.setFields([
        {
          name: 'instructorNumber',
          errors: [formatMessage({ id: 'dm-form-instructor-warning' })],
        },
      ])
      return
    }
    form.setFields([
      {
        name: 'instructorNumber',
        errors: [],
      },
    ])
    run(instructorNumber, type)
  }

  useEffect(() => {
    if (initInstructorInfo) {
      setInstructorVerify(true)
    }
  }, [initInstructorInfo])

  const getInputTitle = () => {
    switch (idType) {
      case 'cd':
        return <FormattedMessage id="owsi-number" />
      case 'trainer':
        return <FormattedMessage id={'efrt-number'} />
      case 'instructor':
        return <FormattedMessage id={'dm-form-instructor-number'} />
      default:
        return ''
    }
  }

  const getPlaceholder = () => {
    switch (idType) {
      case 'cd':
        return formatMessage({ id: 'owsi-cd-tips' })
      case 'trainer':
        return formatMessage({ id: 'efrt-number-warning' })
      case 'instructor':
        return formatMessage({ id: 'dm-form-instructor-warning' })
      default:
        return ''
    }
  }

  const handleChange = (v) => {
    if (instructorVerify) {
      setInstructor(null)
      setInstructorVerify(false)
    }
  }

  const validateField = (_, value) => {
    if (!value) return Promise.reject(new Error('教练编号不能为空'))
    if (!instructorVerify) return Promise.reject(new Error(formatMessage({ id: 'form-instructorNum-verify-error' })))
    if (instructorVerify && value) return Promise.resolve()
  }

  return (
    <>
      <Form.Item
        label={getInputTitle()}
        name="instructorNumber"
        validateTrigger="onSubmit"
        rules={[
          {
            required,
          },
          {
            validator: validateField,
          },
        ]}
        extra={
          instructorVerify ? (
            <CheckCircleFill fontSize={24} color="rgb(150,219,90)" />
          ) : (
            <Button
              size="small"
              color="primary"
              fill="none"
              loading={loading}
              onClick={search}
              loadingText={formatMessage({ id: 'common-search-loading' })}
            >
              <FormattedMessage id="common-search-title" />
            </Button>
          )
        }
      >
        <Input readOnly={!editable} placeholder={getPlaceholder()} onChange={handleChange} />
      </Form.Item>
      {instructor && (
        <Form.Item label={formatMessage({ id: 'common-instructor-name' })}>{instructor.instructorName}</Form.Item>
      )}
    </>
  )
}

export default SearchInstructor
